import { type FC, type ReactNode, useState } from 'react';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useAuth } from '@/providers/auth-provider';
const isUnauthorized = (error: unknown): boolean =>
  error instanceof AxiosError && error.response?.status === 401;
interface TanstackProviderProps {
  children: ReactNode;
}
export const TanstackProvider: FC<TanstackProviderProps> = ({ children }) => {
  const { logout } = useAuth();
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error) => {
            if (isUnauthorized(error)) {
              logout();
            }
          },
        }),
      })
  );
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
